import { useUserRepository } from '@ayocore/platform/identity/client/rpc';
import { createRepositoryFilter } from '@ayocore/platform/client/components/RepositoryTable/createRepositoryFilter';
import type { DealRepository } from '@ayocore/erp/crm/server/repositories/DealRepository';

type UserRepo = ReturnType<typeof useUserRepository>;

/**
 * Фильтр сделок по ответственному менеджеру (multi).
 * Список включает и уволенных/деактивированных менеджеров (onlyHuman, без фильтра
 * по is_active) — нужны для отчётов по сделкам бывших сотрудников. Активные менеджеры
 * идут первыми (orderBy 'is_active' desc), внутри группы — по алфавиту (orderByName).
 * Опция «Без ответственного» (XOR) фильтрует сделки с пустым deal_owner_id.
 */
export const FilterByOwner = createRepositoryFilter<DealRepository, UserRepo>({
  name: 'owner',
  mode: 'multi',
  placeholder: 'Ответственный...',
  width: 220,
  maxDisplayedValues: 1,
  source: () => useUserRepository().onlyHuman().orderBy('is_active', 'desc').orderByName('asc'),
  displayField: 'name',
  by: (repo, ids) => repo.filterByOwners(ids),
  without: { label: 'Без ответственного', apply: repo => repo.filterWithoutOwner() },
});
